// Copyright © 2021 Move Closer
export const SubscriptionServiceType = Symbol.for('ISubscriptionService');
